/**
 * Get today's date
 * @returns {string} Today's date in international ISO-8601 date notation (YYYY-MM-DD)
 */
export default function getToday() {
  return new Date().toISOString().slice(0, 10);
}
